import React from "react";
import { useSiteContent } from "../context/ContentContext";
import { ButtonLink } from "../components/ButtonLink";
import { SiteImage } from "../components/SiteImage";
import { Breadcrumbs, SectionHeading } from "../components/RedlandComponents";

function Slot({ item, testid }) {
  return (
    <div className={`banquet-slot ${item.src ? "" : "is-empty"}`.trim()} data-testid={testid}>
      {item.src ? (
        <SiteImage src={item.src} alt={item.alt} priority fallbackLabel="Redland Golf & Country Club" />
      ) : (
        <div className="banquet-placeholder">
          <span className="banquet-placeholder-mark" aria-hidden="true">
            +
          </span>
          <span>Insert Photo Here</span>
        </div>
      )}
    </div>
  );
}

export default function Banquets() {
  const { banquets } = useSiteContent();
  return (
    <>
      <Breadcrumbs current="Banquets" />
      <section className="section" data-testid="banquets-section">
        <div className="container">
          <SectionHeading
            eyebrow="Private Events"
            title={banquets.title}
            copy={banquets.description}
          />

          <div className="banquet-gallery" aria-label="Banquet photos">
            {banquets.gallery.map((item, index) => (
              <Slot item={item} key={item.id || index} testid={`banquet-slot-${index + 1}`} />
            ))}
          </div>

          <div
            className="banquet-gallery banquet-gallery-portrait"
            aria-label="Additional banquet photos"
          >
            {banquets.portraitGallery.map((item, index) => (
              <Slot
                item={item}
                key={item.id || index}
                testid={`banquet-slot-${banquets.gallery.length + index + 1}`}
              />
            ))}
          </div>

          <div className="section-action">
            <ButtonLink href="/contact-us" data-testid="banquets-plan-event-button">
              Plan Your Event
            </ButtonLink>
          </div>
        </div>
      </section>
    </>
  );
}
